import { render, staticRenderFns } from "./CodeBlock.vue?vue&type=template&id=0cdcfc82"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cdcfc82')) {
      api.createRecord('0cdcfc82', component.options)
    } else {
      api.reload('0cdcfc82', component.options)
    }
    module.hot.accept("./CodeBlock.vue?vue&type=template&id=0cdcfc82", function () {
      api.rerender('0cdcfc82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/code/CodeBlock.vue"
export default component.exports